import { render, staticRenderFns } from "./DescricaoField.vue?vue&type=template&id=c4a36ca0&scoped=true&"
import script from "./DescricaoField.vue?vue&type=script&lang=js&"
export * from "./DescricaoField.vue?vue&type=script&lang=js&"
import style0 from "./DescricaoField.vue?vue&type=style&index=0&id=c4a36ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a36ca0",
  null
  
)

export default component.exports